export const UNSCHEDULED_VISIT_PREFIX = "UNS";
// TODO: Remove legacy "US" support once the UNS migration is complete.
export const LEGACY_UNSCHEDULED_VISIT_PREFIX = "US";
export const UNSCHEDULED_VISIT_PREFIXES = [
  UNSCHEDULED_VISIT_PREFIX,
  LEGACY_UNSCHEDULED_VISIT_PREFIX,
];

/**
 * Trials that spell the visit out ("Unscheduled Visit") instead of using the
 * abbreviated column convention ("UNS Week 2"). Clario's CYTB323K12201 loads a
 * single spelled-out bucket, and matching only the abbreviation left its column
 * unclassified — so the "Show Unscheduled Visits" toggle could never hide it.
 */
const UNSCHEDULED_VISIT_WORD = /^unscheduled\b/i;

/**
 * Canonical uppercase abbreviation a label leads with, or null.
 *
 * Display-casing helper only: the grid title-cases every header, which would
 * render "UNS Week 2" as "Uns Week 2", so the header restores this prefix
 * verbatim. Spelled-out labels are deliberately excluded — they already read
 * correctly title-cased and must not be shouted as "UNSCHEDULED Visit". Use
 * {@link isUnscheduledVisit} to ask whether a visit is unscheduled.
 */
export const getUnscheduledVisitPrefix = (value: unknown): string | null => {
  if (typeof value !== "string") return null;

  return (
    UNSCHEDULED_VISIT_PREFIXES.find((prefix) =>
      new RegExp(`^${prefix}\\b`).test(value),
    ) || null
  );
};

/**
 * Whether a visit label denotes an unscheduled visit, in either the abbreviated
 * ("UNS Week 2", legacy "US Week 2") or spelled-out ("Unscheduled Visit") form.
 */
export const isUnscheduledVisit = (value: unknown): boolean => {
  if (typeof value !== "string") return false;

  return (
    getUnscheduledVisitPrefix(value) !== null ||
    UNSCHEDULED_VISIT_WORD.test(value)
  );
};
